import { BaseService } from "./../../base";
export class LockedDayService extends BaseService {
  static get entity() {
    return "locked_day";
  }
  static get name() {
    return "locked_day";
  }
  static async getByFindYearAndNode(year, nodeId) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_year_and_node_id/${year}/${nodeId}`, this.name);
  }
  static async getByNode(node) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id/${node}`, this.name);
  }
}
